import * as React from "react";
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

export default () => {
  const theme = useTheme();
  const images = APP.richMetadata.getSliderImages();
  SwiperCore.use([Navigation, Pagination, Autoplay]);
  const navigationPrevRef = React.useRef(null)
  const navigationNextRef = React.useRef(null)

  return (
    <div id={'slider-main'} style={{
      width: '100%',
      borderBottom: '1px solid #E5E5E5',
      marginBottom: '30px',
      [theme.breakpoints.up("lg")]: {
        marginBottom: '50px',
      },
    }}>
      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={0}
        slidesPerView={1}
        onSwiper={(swiper) => {}}
        onSlideChange={() => {}}
        navigation={{
          prevEl: navigationPrevRef.current,
          nextEl: navigationNextRef.current,
        }}
        pagination={{ clickable: true, type: "bullets", }}
        autoplay={{ delay: 5000 }}
        loop={true}
        onBeforeInit={(swiper) => {
          swiper.params.navigation.prevEl = navigationPrevRef.current;
          swiper.params.navigation.nextEl = navigationNextRef.current;
        }}
      >
        {images.length > 0 ? images.map((image) => (
          <SwiperSlide className={'swiper-slide'}>
            <img src={image.ImageMobile}
                 srcSet={
                   `${image.ImageMobile} 980w, ${image.Image} 1920w`
                 }
                 sizes={'(max-width: 980px) 980px, 1920px'}
                 style={{
                  position: 'absolute',
                  top: 0,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  objectFit: 'cover',
                  objectPosition: 'center',
                  height: '100%',
                  width: '100%'
            }} />
          </SwiperSlide>
        )) : <p>{I18N("No Slides found")}</p>
        }
        <Box ref={navigationPrevRef} sx={{
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          left: '6%',
          top: 0,
          bottom: 0,
          zIndex: 100,
        }}>
          <ChevronLeftIcon sx={{
            fill: '#fff',
            stroke: '#0000000a',
            opacity: 0.6,
            fontSize: '3.5rem',
            cursor: 'pointer',
            '&:hover': {
              opacity: 1,
              stroke: 'rgba(0,0,0,0.1)',
            },
          }} />
        </Box>
        <Box ref={navigationNextRef} sx={{
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          right: '6%',
          top: 0,
          bottom: 0,
          zIndex: 100,
        }}>
          <ChevronRightIcon sx={{
            fill: '#fff',
            stroke: '#0000000a',
            opacity: 0.6,
            fontSize: '3.5rem',
            cursor: 'pointer',
            '&:hover': {
              opacity: 1,
              stroke: 'rgba(0,0,0,0.1)',
            },
          }} />
        </Box>
      </Swiper>
    </div>
  )
}
